module.exports = __webpack_public_path__ + "img/banner.afe29e55.png";